// extracted by mini-css-extract-plugin
export default {"copyleft":"FW1HxTN9QgBfRO21uro7","link":"dvniOCe1WZu0UZxNXxIg"};